import React, { useContext, useEffect, useState } from "react";
import { Typography, Dialog } from '@mui/material'
import MuiDialogContent from "@mui/material/DialogContent";
import Slide from '@mui/material/Slide';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { ReservationContext } from "../../../contexts/reservation.context";
import { PrinterContext } from "../../../contexts/printer.context";
import socketIOClient from "socket.io-client";
import DialogPaymentStripe from "../../customComponents/payment.stripe";
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js';
import { calcolaOrariDisponibili, filtraOrariConsegne, calculateTotalWithFees, getSelectedVariantsForPrintView, filtraOrariRitiro } from '../../../functions';
import { styleVariants, styleOptions } from "../../../style";
import RoomViewPrint from "../../owner/room/owner.room.dialog.view.print";
import DialogOrarioOccupato from "./DialogOrarioOccupato";
import DialogOpzioneDisabilitata from "./DialogOpzioneDisabilitata";
import OrderSuccessMessage from './OrderSuccessMessage';
import OrderSummaryDetails from './OrderSummaryDetails';

const useStyles = makeStyles((theme) => ({
    dialogContent: { marginTop: theme.spacing(3) },
}));

const stripePromise = loadStripe('pk_test_51PdrV5RsppFK1cnEQuq5VdhTTu9VCP5s3OWbyaxB6CH9LJ0hDw2ObfWZDFm1Dp68E05eZ5OTivyrJfINpnPtgX9G00Qca4sbLR');

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function OrderSummary({
    formData,
    totalPrice,
    goBack,
    cart,
    getDishPrice,
    closeDialogForm,
    isOwner,
    ownerId,
    accountIdPayment,
    goToForm,
    setOpenDialog,
    openDialog,
    user,
    eraseUser,
}) {
    const classes = useStyles();
    const { eraseOrder } = useContext(ReservationContext);
    const { errorOccurred, sendOrderToPrinter_R_C } = useContext(PrinterContext);
    const [socket, setSocket] = useState(null);
    const getSocketId = () => (socket ? socket.id : null);
    const [successOrder, setSuccessOrder] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isOpenDialogPayment, setIsOpenDialogPayment] = useState(false);
    const [clientSecret, setClientSecret] = useState('');
    const [paymentOption, setPaymentOption] = useState('carta');
    const [paymentIntentId, setPaymentIntentId] = useState('');
    const [orarioOccupato, setOrarioOccupato] = useState(false)
    const [isNotConsegnaEnabled, setIsNotConsegnaEnabled] = useState(false);
    const [isNotRitiroEnabled, setIsNotRitiroEnabled] = useState(false);
    const [openDialogPrintMobile, setOpenDialogPrintMobile] = useState(false);
    const oggettoBello = {
        ...formData,
        reservations: cart,
        deliveryId: 'aaa',
        tipo: formData.deliveryOption,
        orario: formData.deliveryTime,
        nome: formData.name,
        cognome: formData.surname,
        telefono: formData.phoneNumber,
        indirizzo: formData.address,
        comune: formData.city,
        noteConsegna: formData.noteDelivery,
    }
    const [newObj, setNewObj] = useState(structuredClone(oggettoBello));
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [lastDeliveryId, setLastDeliveryId] = useState(null);

    useEffect(() => {
        if (user && user.id) {
            const s = socketIOClient(process.env.REACT_APP_SERVER_URL, {
                secure: true,
                transports: ["websocket"],
                query: { ownerId: user.id },
            });
            setSocket(s);
        }// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ownerId]);


    const getSelectedVariants = (items) => {
        // Creiamo un oggetto per raggruppare le opzioni selezionate
        const groupedVariants = {};

        items.variants.forEach(variant => {
            const { name, position, options, selected } = variant;

            // Inizializziamo l'array per il nome della variante se non esiste già
            if (!groupedVariants[name]) {
                groupedVariants[name] = {
                    options: [],
                    position: position // Memorizziamo la posizione
                };
            }
            const selectedOptions = options.filter(option => selected.some(sel => sel.id === option.id));
            const selectedOptionNames = selectedOptions.map(option => option.label);
            groupedVariants[name].options.push(...selectedOptionNames); // Aggiungiamo le opzioni selezionate all'array corrispondente

        });

        // Ordiniamo le varianti in base alla posizione
        const sortedVariants = Object.entries(groupedVariants).sort((a, b) => {
            return a[1].position - b[1].position; // Ordina per posizione
        })

        // Ora convertiamo l'oggetto in una stringa formattata
        return sortedVariants.map(([variantName, { options }]) => (
            <Typography key={variantName} style={{ marginBottom: '4px' }}>
                <strong style={{ ...styleVariants }}>{variantName}:</strong>{' '}
                <span style={{ ...styleOptions }}>{options.join(', ')}</span>
            </Typography>
        )); // Utilizziamo Typography per formattare


    };

    const handleClose = () => {
        setOpenDialogPrintMobile(false);
        setNewObj(structuredClone(oggettoBello));
        sessionStorage.removeItem("cart");
        eraseOrder();
        setOpenDialog(!openDialog)
    };


    const handlePay = () => {
        setLoading(true);
        if (!clientSecret) {
            axios.post('/api/stripe/create-payment-intent', {
                // Puoi passare i dettagli dell'ordine necessari per creare il Payment Intent
                accountId: accountIdPayment,
                totalAmount: calculateTotalWithFees(getSumTotal(), false, paymentOption),
                netAmount: getSumTotal()
                //currency: 'eur',
            }).then(({ data }) => {
                setClientSecret(data.clientSecret);
                setPaymentIntentId(data.paymentIntentId);
                setIsOpenDialogPayment(true); // Apri il dialogo solo dopo aver ottenuto il clientSecret
                setLoading(false);
            }).catch(err => {
                console.error("Errore nel caricamento del clientSecret:", err);
            });
        } else {
            setIsOpenDialogPayment(true);
            setLoading(false);
        }

    }


    const handleOrder = async () => {
        setLoading(true); // Disabilita il pulsante
        let isOrarioAvailable = true;

        if (!isOwner) {
            const deliveryOption = formData.deliveryOption.toLowerCase();

            try {
                const { data } = await axios.post('/api/user/deliveryOptions', {
                    ownerId,
                    deliveryOption: formData.deliveryOption,
                });

                if (data.result.business) {
                    const {
                        abilitaConsegna,
                        abilitaRitiro,
                        openConsegna,
                        closeConsegna,
                        openRitiro,     // Aggiunto
                        closeRitiro,    // Aggiunto
                        attesaRitiro,   // Aggiunto
                        disabledSlotsConsegna, // Aggiunto
                        disabledSlotsRitiro,    // Aggiunto
                        manualUnlocks,          // Aggiunto
                        maxRitiriContemporanei, // Aggiunto
                        maxConsegneExtra,       // Aggiunto
                        abilitaConsegneStessoComune,
                        maxConsegneStessoComune,
                        currentTime_db,
                    } = data.result.business;

                    // 1. Controlli preliminari su abilitazione
                    if (deliveryOption === "consegna" && !abilitaConsegna) {
                        setIsNotConsegnaEnabled(true);
                        setLoading(false);
                        return;
                    }
                    if (deliveryOption === "ritiro" && !abilitaRitiro) {
                        setIsNotRitiroEnabled(true);
                        setLoading(false);
                        return;
                    }

                    // 2. Preparazione variabili tempo
                    const date = new Date(currentTime_db);
                    const currentTime = new Intl.DateTimeFormat("it-IT", {
                        timeStyle: "long",
                        timeZone: "Europe/Rome",
                    }).format(date);
                    const [currentHourStr, currentMinutesStr] = currentTime.split(":");
                    const currentHour = Number(currentHourStr);
                    const currentMinutes = Number(currentMinutesStr);

                    let futureTimes = [];
                    let orariRimasti = [];

                    // 3. Logica Specifica per CONSEGNA
                    if (deliveryOption === "consegna") {
                        let newMinutes = currentMinutes + 10;
                        let newHour = currentHour;
                        if (newMinutes >= 60) {
                            newHour += Math.floor(newMinutes / 60);
                            newMinutes = newMinutes % 60;
                        }
                        const [oH, oM] = openConsegna.split(":").map(Number);
                        const [cH, cM] = closeConsegna.split(":").map(Number);

                        calcolaOrariDisponibili(futureTimes, oH, oM, cH, cM, newHour, newMinutes);

                        const slots = typeof disabledSlotsConsegna === 'string' ? JSON.parse(disabledSlotsConsegna) : disabledSlotsConsegna;
                        const unlocks = typeof manualUnlocks === 'string' ? JSON.parse(manualUnlocks) : manualUnlocks;

                        // Usiamo la nuova funzione con TUTTI i parametri
                        const result = filtraOrariConsegne(
                            futureTimes,
                            data.result.reservation,
                            slots,
                            unlocks,
                            maxConsegneExtra,
                            // Ricontrollo finale: qui il comune e' sempre noto.
                            formData.city,
                            abilitaConsegneStessoComune,
                            maxConsegneStessoComune
                        );
                        orariRimasti = result.orariRimasti;
                    }

                    // 4. Logica Specifica per RITIRO
                    else if (deliveryOption === "ritiro") {
                        let newMinutes = currentMinutes + (attesaRitiro || 0);
                        let newHour = currentHour;
                        if (newMinutes >= 60) {
                            newHour += Math.floor(newMinutes / 60);
                            newMinutes = newMinutes % 60;
                        }
                        const [oH, oM] = openRitiro.split(":").map(Number);
                        const [cH, cM] = closeRitiro.split(":").map(Number);

                        calcolaOrariDisponibili(futureTimes, oH, oM, cH, cM, newHour, newMinutes);

                        const slotsRitiro = typeof disabledSlotsRitiro === 'string' ? JSON.parse(disabledSlotsRitiro) : disabledSlotsRitiro;

                        const result = filtraOrariRitiro(futureTimes, data.result.reservation, slotsRitiro, maxRitiriContemporanei);
                        orariRimasti = result.orariRimasti;
                    }

                    // 5. Validazione finale dell'orario scelto
                    const orariScelti = formData.deliveryTime.includes("-")
                        ? formData.deliveryTime.split(" - ")
                        : [formData.deliveryTime];

                    // Verifichiamo che l'orario (o gli orari dell'intervallo) siano ancora tra quelli rimasti
                    if (orariRimasti.length === 0) {
                        isOrarioAvailable = false;
                    } else {
                        isOrarioAvailable = orariScelti.every((ora) => orariRimasti.includes(ora));
                    }
                }
            } catch (error) {
                console.error("Errore check finale:", error);
                setLoading(false);
                return;
            }
        }

        if (isOrarioAvailable) {
            axios
                .post("/api/reservation/user/orderDelivery", {
                    ...formData,
                    cart: cart.filter(({ amount }) => amount > 0),
                    ownerId,
                    socketId: getSocketId(),
                    isOwner,
                    selectedCoupon,
                })
                .then(({ data }) => {
                    if (data.success) {

                        if (user.id === 'anonymus') {
                            // Creiamo un pacchetto di dati da "portare" alla registrazione
                            const claimData = {
                                deliveryId: data.deliveryId,
                                email: formData.email,
                                name: formData.name,
                                surname: formData.surname,
                                telefono: formData.phoneNumber
                            };
                            // Salviamo nel sessionStorage come stringa JSON

                            sessionStorage.setItem('pendingOrderClaim', JSON.stringify(claimData));
                            setLastDeliveryId(data.deliveryId);
                        }

                        setSuccessOrder(true);
                        if (isOwner && !errorOccurred) {
                            sendOrderToPrinter_R_C(data.deliveryId);
                        }
                        if (!isOwner) {
                            sessionStorage.removeItem("reservationDishes");
                            sessionStorage.removeItem("cart");
                            eraseOrder();
                        }
                    }
                })
                .catch((error) => {
                    console.error("Errore nel creare l'ordine:", error);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setOrarioOccupato(true);
            setLoading(false);
        }
    };



    const handlePayOptionChange = (event) => {
        setPaymentOption(event.target.value);
        getSumTotal();
    };

    const getSumTotal = () => {
        let costoConsegna = 0;
        if (formData.deliveryOption.toLowerCase() === 'consegna') {
            costoConsegna = parseFloat(formData.costoConsegna) || 0;
        }

        let totale = totalPrice;

        if (selectedCoupon) {
            totale = Math.max(0, totale - parseFloat(selectedCoupon.value));
        }

        totale += costoConsegna;

        return totale;
    }

    const handleClickPrintRemove = () => {

        let copyNewObj = newObj;
        for (const obj in copyNewObj.reservations) {
            var variantString = getSelectedVariantsForPrintView(copyNewObj.reservations[obj].variants);
            copyNewObj.reservations[obj].variant = variantString;
            copyNewObj.reservations[obj].lastUpdate = new Date().toISOString();
            var priceFixed = getDishPrice(copyNewObj.reservations[obj]);
            copyNewObj.reservations[obj].price = priceFixed
        }
        setNewObj(copyNewObj);
        //avvia stampa
        setOpenDialogPrintMobile(!openDialogPrintMobile)
    }

    return (
        <>
            {/* TODO: refactoring di sto codice */}
            <DialogOrarioOccupato open={orarioOccupato} onClose={goBack} />

            <DialogOpzioneDisabilitata isRitiro={isNotRitiroEnabled} isConsegna={isNotConsegnaEnabled} onClose={goToForm} />

            {/** VERSIONE STAMPABILE*/}
            <Dialog onClose={handleClose} open={openDialogPrintMobile} fullScreen TransitionComponent={Transition}>
                <MuiDialogContent dividers className={classes.dialogContent}>
                    <RoomViewPrint paymentIntentId={paymentIntentId} handleClose={handleClose} classes={classes} table={newObj} statesSconti={{ nuovoTotalPrice: 0, scontoTotalPrice: 0, costoConsegna: user.costoConsegna }}  /*tableId={tableId}   */ />
                </MuiDialogContent>
            </Dialog>
            {/** VERSIONE STAMPABILE*/}

            {successOrder ? (
                <OrderSuccessMessage
                    isOwner={isOwner}
                    errorOccurred={errorOccurred}
                    handleClickPrintRemove={handleClickPrintRemove}
                    user={user}
                    closeDialogForm={closeDialogForm}
                    deliveryId={lastDeliveryId}
                />
            ) : (
                <OrderSummaryDetails
                    user={user}
                    eraseUser={eraseUser}
                    ownerId={ownerId}
                    formData={formData}
                    cart={cart}
                    getDishPrice={getDishPrice}
                    getSelectedVariants={getSelectedVariants}
                    accountIdPayment={accountIdPayment}
                    totalPrice={totalPrice}
                    paymentOption={paymentOption}
                    isOwner={isOwner}
                    getSumTotal={getSumTotal}
                    handlePayOptionChange={handlePayOptionChange}
                    goBack={goBack}
                    handleOrder={handleOrder}
                    handlePay={handlePay}
                    loading={loading}
                    setLoading={setLoading}
                    setSelectedCoupon={setSelectedCoupon}
                    selectedCoupon={selectedCoupon}
                />
            )}

            {clientSecret && isOwner === false && (
                <Elements stripe={stripePromise} options={{ clientSecret: clientSecret }}>
                    <DialogPaymentStripe
                        setIsOpenDialogPayment={setIsOpenDialogPayment}
                        isOpenDialogPayment={isOpenDialogPayment}
                        formData={formData}
                        cart={cart}
                        ownerId={ownerId}
                        getSocketId={getSocketId}
                        isOwner={isOwner}
                        eraseOrder={eraseOrder}
                        paymentIntentId={paymentIntentId}
                    />
                </Elements>
            )}

        </>
    );
}

export default OrderSummary;
